import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";
import Gem from "./Gem";
import ABCyaLib from "@abcya/abcya_lib";

export default class Popup extends Phaser.GameObjects.Container
{
    constructor(scene, t)
    {
        super(scene);
        scene.add.existing(this);
        this.setPosition(this.scene.mid.x, this.scene.mid.y);
        this.setDepth(10);

        this.scene = scene;
        this.type = t;
        this.isEnd = false;
        this.isActive = false;

        this.wobbleCounter = 15;

        this.btnCont = this.scene.add.container();
        this.cartCont = this.scene.add.container();
        this.topCont = this.scene.add.container();

        this.cartCont.add(this.topCont);
		
        this.createPopup();
        this.showPopup();
    }

	createPopup() {
        let txt;
        
        this.bgShade = ABCyaPhaser.Graphics.addRect(0, 0, this.scene.mid.x*2, this.scene.mid.y*2, "0x000000", this).setAlpha(0);

        this.replayBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, "ExitBtn", null, ()=>{
            this.clickHandler("replay");
        }, this.btnCont).setEnabled(false);

        this.cart = ABCyaPhaser.Images.addImage(0, 0, "MineCartBody", this.topCont);
        this.wheel1 = ABCyaPhaser.Images.addImage(0, 0, "MineCartWheel", this.cartCont);
        this.wheel2 = ABCyaPhaser.Images.addImage(0, 0, "MineCartWheel", this.cartCont);

        if(this.type == "pause"){
            txt = "Paused";
            this.popupTxt = ABCyaPhaser.Text.addText(0, -this.scene.mid.y/4, 50, "0xFFFFFF", gameData.GAME_FONTS[1], txt, this.topCont, true);            

            this.resumeBtn = ABCyaPhaser.Buttons.addSimpleButton(-this.scene.mid.x/4, 0, "StartBtn", null, ()=>{
                this.clickHandler("resume");
            }, this.btnCont).setEnabled(false);
        }

        if(this.type == "end") {
            this.isEnd = true;
            txt = "Great Job";
            this.popupTxt = ABCyaPhaser.Text.addText(0, -this.scene.mid.y/4, 50, "0xFFFFFF", gameData.GAME_FONTS[1], txt, this.topCont, true);
            
            if(gameData.TOTALS.length > 0){
                this.pointsTxt = ABCyaPhaser.Text.addText(0, 0, 30, "0xFFFFFF", gameData.GAME_FONTS[1], gameData.TOTALS[0], this.btnCont, true);
            } else {
                this.pointsTxt = ABCyaPhaser.Text.addText(0, 0, 30, "0xFFFFFF", gameData.GAME_FONTS[1], "0", this.btnCont, true);
            }

            this.points = ABCyaPhaser.Images.addImage(-this.scene.mid.x/4, 0, "ScoreCounterBarCart", this.btnCont);
        }

        if(this.type == "lose") {
            console.log("TIMES UP");
            txt = "Time's Up";

            this.points = ABCyaPhaser.Images.addImage(-this.scene.mid.x/4, -40, "ScoreCounterBarCart", this.btnCont);
            this.score = ABCyaPhaser.Images.addImage(-this.scene.mid.x/4, 0, "GemCounterBarCart", this.btnCont);
            this.popupTxt = ABCyaPhaser.Text.addText(0, -this.scene.mid.y/4, 50, "0xFFFFFF", gameData.GAME_FONTS[1], txt, this.topCont, true);
            this.pointsTxt = ABCyaPhaser.Text.addText(0, 0, 30, "0xFFFFFF", gameData.GAME_FONTS[1], gameData.TOTALS[0] ?? "0", this.btnCont, true);
            this.scoreTxt = ABCyaPhaser.Text.addText(0, 0, 25, "0xFFFFFF", gameData.GAME_FONTS[1], gameData.TOTALS[1]?? "0", this.btnCont, true);
            console.log(gameData.TOTALS)

            if(gameData.GAME_MODE == "arcade"){
                this.totalTxt = ABCyaPhaser.Text.addText(0, 0, 25, "0xFFB42E", gameData.GAME_FONTS[1], "/50", this.btnCont, true);
            } else {
                this.totalTxt = ABCyaPhaser.Text.addText(0, 0, 25, "0xFFB42E", gameData.GAME_FONTS[1], "/100", this.btnCont, true);
            }
        }

        if(this.pointsTxt){
            this.pointsTxt.x = this.points.x;
            this.pointsTxt.y = this.points.y;
        }
        if(this.scoreTxt){
            this.score.y = 40;
            this.scoreTxt.x = this.score.x - 20;
            this.scoreTxt.y = this.score.y;
            this.totalTxt.x = this.score.x + 40;
            this.totalTxt.y = this.score.y;
        }

        this.btnCont.y = 15;
        this.cartCont.x = -this.cart.getBounds().width;

        this.replayBtn.x = this.scene.mid.x/4;

        this.wheel1.y = this.wheel2.y = this.cart.getBounds().height/2 + 16;
        this.wheel1.x = -(this.scene.mid.x*2)/6.5 - 6;
        this.wheel2.x = (this.scene.mid.x*2)/6.5 + 2;
        this.wheel2.angle = 15;

        this.popupTxt.setStroke('#CC8800', 4);

        this.topCont.add(this.btnCont);

        this.add(this.cartCont);
	};

    showPopup(){
        //animate in all the pieces
        ABCyaPhaser.Tweens.addTween(this.bgShade, 750, {alpha:.75}, Phaser.Math.Easing.Linear);

        this.moveCart("in");
    };

    moveCart(type){
        const endX = 0;
        if(type == "in"){
            this.isActive = true;
            this.rollWheels(1); 
            this.rollWheels(2);

            ABCyaPhaser.Tweens.addTween(this.cartCont, 400, {x:endX}, Phaser.Math.Easing.Linear, ()=>{
                this.moveCart("upIn");
            });
        }
        if(type == "upIn"){
            ABCyaPhaser.Audio.playOneShot("mine_cart_stop", this.scene);

            ABCyaPhaser.Tweens.addTween(this.cartCont, 300, {angle:15, y:-25, x:endX+50}, Phaser.Math.Easing.Quadratic.Out, ()=>{
                this.moveCart("downIn");
            });
        }
        if(type == "downIn"){
            this.stopWheel(2);

            ABCyaPhaser.Tweens.addTween(this.cartCont, 200, {delay:100, angle:0, y:0, x:endX}, Phaser.Math.Easing.Quadratic.In, ()=>{
                this.stopWheel(1);
            });
        }
        if(type == "out"){
            ABCyaPhaser.Tweens.addTween(this.cartCont, 400, {x:this.scene.mid.x*2 + this.cart.getBounds().width}, Phaser.Math.Easing.Linear, ()=>{
                this.isActive = false;
                this.scene.destroyPopup("resume");
            });
        }
        if(type == "upOut"){
            this.isActive = true;

            ABCyaPhaser.Audio.playOneShot("mine_cart_stop", this.scene);
            this.rollWheels(2);

            ABCyaPhaser.Tweens.addTween(this.cartCont, 300, {angle:-15, y:-25, x:endX-50}, Phaser.Math.Easing.Quadratic.Out, ()=>{
                this.moveCart("downOut");
            });
        }
        if(type == "downOut"){
            this.rollWheels(1);

            ABCyaPhaser.Tweens.addTween(this.cartCont, 300, {delay:100, angle:0, y:0, x:endX}, Phaser.Math.Easing.Quadratic.In, ()=>{
                this.moveCart("out");
            });
        }
        if(type == "wobble"){
            this.wobbleCounter--;

            if(this.wobbleCounter > 0){
                this.contTween = ABCyaPhaser.Tweens.addTween(this.topCont, 50, {y:Phaser.Math.Between(-5, 5), x: Phaser.Math.Between(-5, 5)}, Phaser.Math.Easing.Linear, ()=>{
                    this.moveCart("wobble");
                });
            } else {
                this.contTween = ABCyaPhaser.Tweens.addTween(this.topCont, 50, {y:Phaser.Math.Between(-5, 5), x: Phaser.Math.Between(-5, 5)}, Phaser.Math.Easing.Linear, ()=>{
                    this.moveCart("jump");
                });
            }
        }
        if(type == "jump"){
            this.wobbleCounter = 20;
            this.topCont.x = this.topCont.y = 0;
            this.scene.time.delayedCall(250, ()=>{this.barfGems();});

            this.contTween = ABCyaPhaser.Tweens.addTween(this.cartCont, 400, {delay:250, y:-50}, Phaser.Math.Easing.Quadratic.Out, ()=>{
                this.contTween = ABCyaPhaser.Tweens.addTween(this.cartCont, 400, {y:0}, Phaser.Math.Easing.Quadratic.In);
            });

            this.cTween = ABCyaPhaser.Tweens.addTween(this.topCont, 250, {y:15}, Phaser.Math.Easing.Linear, ()=>{
                this.cTween = ABCyaPhaser.Tweens.addTween(this.topCont, 250, {y:0}, Phaser.Math.Easing.Linear, ()=>{
                    this.cTween = ABCyaPhaser.Tweens.addTween(this.topCont, 250, {delay:600, y:15}, Phaser.Math.Easing.Linear, ()=>{
                        this.cTween = ABCyaPhaser.Tweens.addTween(this.topCont, 250, {y:0}, Phaser.Math.Easing.Linear);
                    });
                });
            });
        }
    };

    rollWheels(wheel){
        if(this.isActive)
        {
            if(wheel == 0){
                this.wheel1.angle = 0;
                this.wheel2.angle = 15;
                this.wTween1 = ABCyaPhaser.Tweens.addTween(this.wheel1, 500, {angle:360}, Phaser.Math.Easing.Linear, ()=>{
                    this.rollWheels(1);
                });
                this.wTween2 = ABCyaPhaser.Tweens.addTween(this.wheel2, 500, {angle:375}, Phaser.Math.Easing.Linear, ()=>{
                    this.rollWheels(2);
                });
            }
            if(wheel == 1){
                this.wheel1.angle = 0;
                this.wTween1 = ABCyaPhaser.Tweens.addTween(this.wheel1, 500, {angle:360}, Phaser.Math.Easing.Linear, ()=>{
                    this.rollWheels(1);
                });
            }
            if(wheel == 2){
                this.wheel2.angle = 15;
                this.wTween2 = ABCyaPhaser.Tweens.addTween(this.wheel2, 500, {angle:375}, Phaser.Math.Easing.Linear, ()=>{
                    this.rollWheels(2);
                });
            }
        }
    };

    stopWheel(wheel){
        if(wheel == 1){
            if(this.isEnd){
                ABCyaPhaser.Audio.playOneShot("Rumble_Explode", this.scene);
                this.moveCart("wobble");
            }
            this.isActive = false;

            this.popupReady();
            this.wTween1.stop();
            this.scene.tweens.killTweensOf(this.wheel1);
        }
        if(wheel == 2){
            this.wTween2.stop();
            this.scene.tweens.killTweensOf(this.wheel2);
        }
    };

    barfGems(){
        this.coinSound = ABCyaPhaser.Audio.playOneShot("Gem_Shower", this.scene);//MAKE THIS LOOP

        let randIndi = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        let randIndi2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        ABCyaPhaser.Arrays.shuffle(randIndi);
        ABCyaPhaser.Arrays.shuffle(randIndi2);

        //create the 12 gem curves there they will exit the top of the cart
        for(let i = 0; i < 12; i++){
            let miniGem = new Gem(this.scene, this, randIndi[i], randIndi[i], true);
            this.cartCont.addAt(miniGem, 0);

            let randStart = Phaser.Math.Between(-200, 200);
            let randWidth = Phaser.Math.Between(-800, 800);
            let randHeight = Phaser.Math.Between(-1200, -600);
            miniGem.x = randStart;
            miniGem.y = -125;
            miniGem.angle = 0;

            this.scene.time.delayedCall(175*i, ()=>{this.setBarfInd(miniGem)});
            let path = new Phaser.Curves.Path(randStart, -125).quadraticBezierTo(randWidth, 500, randStart, randHeight);
            ABCyaPhaser.Tweens.addPathTween(miniGem, path, 1500, {delay:100*i }, Phaser.Math.Easing.Linear, () => this.continueBarf(miniGem));
            ABCyaPhaser.Tweens.addTween(miniGem, 1500, {angle:360 * Phaser.Math.Between(1,3), delay:100*i}, Phaser.Math.Easing.Linear);
        }
        for(let i2 = 0; i2 < 12; i2++){
            let miniGem2 = new Gem(this.scene, this, randIndi2[i2], randIndi[i2], true);
            this.cartCont.addAt(miniGem2, 0);

            let randStart2 = Phaser.Math.Between(-200, 200);
            let randWidth2 = Phaser.Math.Between(-800, 800);
            let randHeight2 = Phaser.Math.Between(-1200, -600);
            miniGem2.x = randStart2;
            miniGem2.y = -125;
            miniGem2.angle = 0;

            this.scene.time.delayedCall(175*i2, ()=>{this.setBarfInd(miniGem2)});

            let path = new Phaser.Curves.Path(randStart2, -125).quadraticBezierTo(randWidth2, 500, randStart2, randHeight2);
            ABCyaPhaser.Tweens.addPathTween(miniGem2, path, 1500, {delay:100*i2 }, Phaser.Math.Easing.Linear, () => this.continueBarf(miniGem2));
            ABCyaPhaser.Tweens.addTween(miniGem2, 1500, {angle:360 * Phaser.Math.Between(1,3), delay:100*i2}, Phaser.Math.Easing.Linear);
        }
    };

    continueBarf(obj){
        this.cartCont.moveTo(obj, 0);

        let randStart = Phaser.Math.Between(-200, 200);
        let randWidth = Phaser.Math.Between(-800, 800);
        let randHeight = Phaser.Math.Between(-1200, -600);
        obj.x = randStart;
        obj.y = -125;
        obj.angle = 0;

        if(randWidth > -400 && randWidth <= 0){
            randWidth = Phaser.Math.Between(-600, -400);
        }
        if(randWidth >= 0 && randWidth < 400){
            randWidth = Phaser.Math.Between(400, 600);
        }

        this.scene.time.delayedCall(175, ()=>{this.setBarfInd(obj)});
        let path = new Phaser.Curves.Path(randStart, -125).quadraticBezierTo(randWidth, 500, randStart, randHeight);
        ABCyaPhaser.Tweens.addPathTween(obj, path, 1500, {}, Phaser.Math.Easing.Linear, () => this.continueBarf(obj));
        ABCyaPhaser.Tweens.addTween(obj, 1500, {angle:360 * Phaser.Math.Between(1,3)}, Phaser.Math.Easing.Linear);
    };

    setBarfInd(obj){
        this.cartCont.moveTo(obj, this.cartCont.list.length-1);
    };

    endBarf(type){
        if(type == "repeat"){
            this.moveCart("wobble");
        }

        while(this.cartCont.list.length > 3){
            this.cartCont.list[2].destroy();
        }
    };

    popupReady(){
        //add listeners and whatnot
        this.resumeBtn?.setEnabled(true);
        this.replayBtn?.setEnabled(true);
    };

    clickHandler(event){
        this.resumeBtn?.setEnabled(false);
        this.replayBtn?.setEnabled(false);
        this.btnSound = ABCyaPhaser.Audio.playOneShot("Click", this.scene);

        //Resume the game. Turn back on all listeners
        if(event == "resume"){
            this.moveCart("upOut");
        }
        if(event == "replay"){
            // console.log(gameData.GAME_LEVEL);
            // const score = Number(gameData.TOTALS[0]);
            // console.log('grabbed early',score)

            // if(this.coinSound)
            // {
            //     this.coinSound.stop();
            // }
            // this.coinSound = null;

            if(gameData.GAME_LEVEL == 9) gameData.GAME_LEVEL = 8; 
            // console.log("score = " + gameData.LEVELS[gameData.GAME_LEVEL].score);

            if(gameData.GAME_MODE == "arcade"){
                if(gameData.GAME_LEVEL > 0){
                    if(Number(gameData.TOTALS[0]) > gameData.LEVELS[gameData.GAME_LEVEL].score){
                        gameData.LEVELS[0].score = Number(gameData.TOTALS[0]);
                    }
                }
            } else {
                if(Number(gameData.TOTALS[0]) > gameData.LEVELS[gameData.GAME_LEVEL].score){
                    // console.log("changing LEVELS score");
                    // console.log('grabbed late', Number(gameData.TOTALS[0]))
                    gameData.LEVELS[gameData.GAME_LEVEL].score = Number(gameData.TOTALS[0]);
                }
            }

            ABCyaLib.Storage.saveObject("levels", gameData.LEVELS);
            gameData.LEVELS = 0;

            this.scene.cleanUp();
        }
    };
}